var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1014 15.9997L20.8402 12.2607C20.9431 12.1577 20.9998 12.0204 21 11.874C21 11.7275 20.9433 11.59 20.8402 11.4872L20.5126 11.1597C20.4096 11.0565 20.2723 11 20.1257 11C19.9793 11 19.842 11.0565 19.739 11.1597L16.0002 14.8985L12.2611 11.1597C12.1583 11.0565 12.0209 11 11.8744 11C11.728 11 11.5907 11.0565 11.4878 11.1597L11.16 11.4872C10.9467 11.7006 10.9467 12.0476 11.16 12.2607L14.8989 15.9997L11.16 19.7385C11.0571 19.8416 11.0004 19.9789 11.0004 20.1254C11.0004 20.2718 11.0571 20.4091 11.16 20.5121L11.4877 20.8397C11.5906 20.9428 11.728 20.9993 11.8743 20.9993C12.0208 20.9993 12.1582 20.9428 12.2611 20.8397L16.0001 17.1008L19.7389 20.8397C19.842 20.9428 19.9793 20.9993 20.1256 20.9993H20.1258C20.2722 20.9993 20.4095 20.9428 20.5125 20.8397L20.8402 20.5121C20.943 20.4092 20.9998 20.2718 20.9998 20.1254C20.9998 19.9789 20.943 19.8416 20.8402 19.7386L17.1014 15.9997Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ec9b0428f5bee4d9ab97994494fef91c.svg";
export { ForwardRef as ReactComponent };